import { Container, Panel, Sidenav, Content, Dropdown, Message, IconButton, Popover, Whisper } from "rsuite"
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import NoticeIcon from '@rsuite/icons/Notice';

import { forwardRef, useEffect, useState } from "react";
import { formatTimestamp } from "../../utils/formatTimestamp";
import { useParams, Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

export default function Header({pageName}) {
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);

    const cookies = new Cookies();

    const getNotifications = () => {
        setLoading(true);

        fetch(`/api/notifications/get`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + cookies.get('token'),
            }
        }).then((res) => {
            if (!res.ok || !res.headers.get('content-type')?.includes('application/json')) {
                setLoading(false)
                return
            }
            res.json().then((data) => {
                setNotifications(data)
                setLoading(false)
            })
        })
    }

    useEffect(() => {
        getNotifications()
    }, [])

    const speaker = (
        <Popover className="page-notifications" title="Уведомления" style={{ width: 200 }}>
          <div >
            {
                notifications.map((notification) => (
                    <Message header={
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <strong>{notification.title}</strong>
                            <span style={{fontSize: 12, color: "var(--rs-text-secondary"}}>{formatTimestamp(notification.created_at)}</span>
                        </div>
                    }>{notification.message}</Message>
                ))
            }
          </div>
        </Popover>
    );


    return (
        <Whisper placement="bottomRight" trigger="click" speaker={speaker}>
            <IconButton size="lg" icon={<NoticeIcon />} />
        </Whisper>
    )
}